import { get, find } from 'lodash';

export const supportedCountries = ['US', 'FR', 'IT', 'ES', 'GB'];

export const NAV_TABS = {
  ACCEPT_VIRTUAL_PAYMENTS: 'acceptPaymentsVirtual',
  PAYMENTS_QR: 'acceptPaymentsInPerson',
  SELL_ONLINE: 'sellOnline',
  SELL_ON_WEBSITE: 'sellOnWebsite',
  RAISE_FINANCIAL_SUPPORT: 'raiseFinancialSupport'
};

export const BIG_COMMERCE = 'bigCommerce';

/*
  Bundles - defines products included in each bundles
*/
let bundles = {
  sellOnline: {
    image: '',
    heroProduct: 'sellOnSocial',
    suggestedProducts: ['paypalMe'],
    ppObjectLink: {
      normal: 'https://www.paypalobjects.com/ppcp/images/covid/default.svg',
      blue: 'https://www.paypalobjects.com/ppcp/images/covid/hover.svg'
    }
  },
  acceptPaymentsInPerson: {
    image: '',
    heroProduct: 'qrCode',
    suggestedProducts: ['pointOfSale'], // TODO: should it be iZettle (Carla)
    ppObjectLink: {
      normal: 'https://www.paypalobjects.com/ppcp/images/covid/qr-code.svg',
      blue: 'https://www.paypalobjects.com/ppcp/images/covid/qr-hover.svg'
    }
  },
  acceptPaymentsVirtual: {
    image: '',
    heroProduct: 'quickInvoice',
    suggestedProducts: ['invoicing', 'paypalMe', 'requestMoney'],
    ppObjectLink: {
      normal: 'https://www.paypalobjects.com/ppcp/images/covid/request.svg',
      blue: 'https://www.paypalobjects.com/ppcp/images/covid/request-hover.svg'
    }
  },
  sellOnWebsite: {
    image: '',
    heroProduct: 'bigCommerce',
    suggestedProducts: [
      'paypalCheckout',
      'paypalButton',
      'subscriptions',
      'donateButton'
    ],
    ppObjectLink: {
      normal:
        'https://www.paypalobjects.com/ppcp/images/covid/online-store.svg',
      blue:
        'https://www.paypalobjects.com/ppcp/images/covid/online-store-hover.svg'
    }
  }
};

/* 
  Overrides any bundle specific details. Can be country / ELMO, etc.
*/
const _bundleOverrides = {};

/*
  The _links property holds all links for the page. All links should be available in `default`, any overrides should a separate property. 
  The overrides resolution happens in `_resolveLink` method. 
  We can use the overrides for country / ELMO, etc. 
*/
const _links = {
  default: {
    requestMoney: 'https://www.paypal.com/myaccount/transfer/homepage/request',
    venmoAndroid: 'https://play.google.com/store/apps/details?id=com.venmo',
    venmoIOS: 'https://apps.apple.com/us/app/venmo/id351727428',
    invoicing: 'https://www.paypal.com/invoice/create',
    ppme: 'https://www.paypal.com/paypalme/my',
    quickInvoiceIOS: 'https://apps.apple.com/app/paypal/id1053148887',
    quickInvoiceAndroid:
      'https://play.google.com/store/apps/details?id=com.paypal.merchant.client',
    qrCode: 'https://www.paypal.com/us/webapps/mpp/qr-code-download',
    sellOnSocial: 'https://www.paypal.com/instantcommerce',
    bigCommerce:
      'https://www.bigcommerce.com/paypal-theme-offer/?utm_medium=partner&utm_source=paypal&utm_campaign=USA_SB_PAR_None_Other_2020_Q2-in-product-feature',
    ppCheckout: 'https://developer.paypal.com/docs/business/checkout/',
    ppButtons: 'https://www.paypal.com/commercesetup/createButton',
    subscriptions: 'https://www.paypal.com/billing/overview',
    donate: 'https://www.paypal.com/donate/buttons',
    donateHero:
      'https://www.paypal.com/donate/buttons/partner?bn=generic&entry=bundle',
    paypalHere: 'https://www.paypal.com/bizsignup/entry?product=pph',
    iZettle:
      'https://www.paypal.com/connect/?client_id=AVA2WaMQOLEpNw0eZZWU--neIIJDLpymsctM4kg1f3f78HkJwhQW1uZu_5m4h_iYEqkdZE2gCw4Pcu8o&redirect_uri=https%3A%2F%2Flogin.izettle.com%2Foauth&response_type=code&source=ppcp',
    ppdg:
      'https://www.paypal.com/commerce-apps/gift-cards/get-started?entry=bundles'
  },
  GB: {
    bigCommerce:
      'https://www.bigcommerce.co.uk/dm/24-hours/?utm_medium=partner&utm_source=paypal&utm_campaign=EMEA_SB_PAR_None_Other_2020_Q2-in-product-feature_UK',
    qrCode: 'https://www.paypal.com/uk/webapps/mpp/qr-code-download',
    quickInvoiceIOS:
      'https://apps.apple.com/gb/app/paypal-business-invoice-maker/id1053148887'
  },
  FR: {
    qrCode: 'https://www.paypal.com/fr/webapps/mpp/qr-code-download',
    quickInvoiceIOS:
      'https://apps.apple.com/fr/app/paypal-business-invoice-maker/id1053148887'
  },
  IT: {
    qrCode: 'https://www.paypal.com/it/webapps/mpp/qr-code-download',
    quickInvoiceIOS:
      'https://apps.apple.com/it/app/paypal-business-invoice-maker/id1053148887'
  },
  ES: {
    qrCode: 'https://www.paypal.com/es/webapps/mpp/qr-code-download',
    quickInvoiceIOS:
      'https://apps.apple.com/es/app/paypal-business-invoice-maker/id1053148887'
  }
};

const _resolveLink = (countryLinks, linkName) => {
  return (
    countryLinks[linkName] ||
    _links.default[linkName] ||
    'https://www.paypal.com'
  );
};

/*
  Products holds all products (both hero and suggested) & its information
  Images - pp-vx icon names
  Links - key for the link available in `_links` property above
  mobileApps - indicates if a product has android & iOS links separately
*/
export const products = {
  ppdg: {
    image: 'https://www.paypalobjects.com/ppcp/images/covid/giftcard.svg',
    imageType: 'CDN',
    link: 'ppdg',
    intent: 'pp_digital_giftcard'
  },
  invoicing: {
    image: 'invoice',
    link: 'invoicing'
  },
  quickInvoice: {
    image: 'invoice',
    link: '',
    mobileApps: true,
    androidLink: 'quickInvoiceAndroid',
    iosLink: 'quickInvoiceIOS'
  },
  paypalMe: {
    image: 'link',
    link: 'ppme',
    intent: 'pp_me',
    activationStatus: {
      isActive: false,
      type: 'RPS',
      long_name: 'ppme_slug_active_y_n'
    }
  },
  requestMoney: {
    image: 'request',
    link: 'requestMoney'
  },
  pointOfSale: {
    image: 'credit-debit-cards',
    link: 'paypalHere',
    intent: 'pp_here',
    countries: ['US'],
    activationStatus: {
      isActive: false,
      type: 'RPS',
      long_name: 'pph_status_y_n'
    }
  },
  qrCode: {
    image: 'scan-to-send',
    intent: 'qr_code',
    link: 'qrCode'
  },
  sellOnSocial: {
    image: 'store',
    link: 'sellOnSocial'
  },
  bigCommerce: {
    image: 'https://www.paypalobjects.com/ppcp/images/partners/bigcommerce.svg',
    imageType: 'CDN',
    link: 'bigCommerce',
    countries: ['US', 'GB']
  },
  paypalButton: {
    image: 'https://www.paypalobjects.com/ppcp/images/buttons.svg',
    imageType: 'CDN',
    link: 'ppButtons',
    intent: 'pp_buttons',
    activationStatus: {
      isActive: false,
      type: 'RPS',
      long_name: 'txn_rcvd_brandedxoec_count_6mth'
    }
  },
  paypalCheckout: {
    image: 'cart',
    link: 'ppCheckout',
    intent: 'pp_checkout',
    activationStatus: {
      isActive: false,
      type: 'RPS',
      long_name: 'txn_rcvd_brandedxoec_count_6mth'
    }
  },
  subscriptions: {
    image: 'recurring',
    link: 'subscriptions',
    intent: 'pp_subscriptions_v1',
    activationStatus: {
      isActive: false,
      type: 'RPS',
      long_name: 'has_active_subscr_paymt'
    }
  },
  donateButton: {
    image: 'https://www.paypalobjects.com/ppcp/images/covid/donatebtn.svg',
    imageType: 'CDN',
    link: 'donate'
  },
  donationHero: {
    image: 'donate',
    link: 'donateHero'
  },
  paypalGiftCards: {
    image: 'cart',
    link: ''
  },
  venmo: {
    image: '',
    link: '',
    mobileApps: true,
    androidLink: 'venmoAndroid',
    iosLink: 'venmoIOS'
  }
};

const pointOfSales = {
  link: 'iZettle',
  intent: 'pp_izettle',
  countries: ['GB', 'FR'],
  activationStatus: {}
};
const productOverrides = {
  US: {
    qrCode: {
      tempWaiverDate: 'July 31, 2020',
      fee: '1.90%+$0.10'
    }
  },
  GB: {
    pointOfSale: {
      ...pointOfSales
    },
    qrCode: {
      tempWaiverDate: 'September 14, 2020',
      fee: '1.50%+£0.10'
    }
  },
  FR: {
    pointOfSale: {
      ...pointOfSales
    },
    qrCode: {
      tempWaiverDate: 'September 14, 2020',
      fee: '0.60%+€0.10'
    }
  },
  IT: {
    pointOfSale: {
      ...pointOfSales
    },
    qrCode: {
      tempWaiverDate: 'September 14, 2020',
      fee: '0.50%+€0.20'
    }
  },
  ES: {
    pointOfSale: {
      ...pointOfSales
    },
    qrCode: {
      tempWaiverDate: 'September 14, 2020',
      fee: '0.90%+€0.10'
    }
  }
};

const _setActivationStatus = (product, productcompletion) => {
  if (product.activationStatus && product.activationStatus.type === 'RPS') {
    let profileAttributes = get(
        productcompletion,
        'rpsAttributes.profile_attributes',
        []
      ),
      productRpsObj = find(profileAttributes, {
        long_name: product.activationStatus.long_name
      });
    product.activationStatus.isActive =
      get(productRpsObj, 'value') === 'Y' || get(productRpsObj, 'value') > 0;

    // do not trigger setup card, if product is already active
    if (product.activationStatus.isActive) {
      delete product.intent;
    }
  }
  return;
};

const handleExperimentation = experimentation => {
  let newBundles;
  if (get(experimentation, 'covidBundleGiftCard')) {
    get(bundles, 'acceptPaymentsInPerson.suggestedProducts', []).push('ppdg');
  }
  if (get(experimentation, 'covidFinancialSection')) {
    newBundles = {
      raiseFinancialSupport: {
        image: '',
        heroProduct: 'donationHero',
        suggestedProducts: ['donateButton'],
        ppObjectLink: {
          normal: 'https://www.paypalobjects.com/ppcp/images/covid/support.svg',
          blue:
            'https://www.paypalobjects.com/ppcp/images/covid/support-blue.svg'
        }
      },
      ...bundles
    };
    if (get(experimentation, 'covidBundleGiftCard')) {
      newBundles.raiseFinancialSupport.suggestedProducts.push('ppdg');
    }
  }
  return newBundles ? newBundles : bundles;
};

// resolve any country-specific overrides / country-specific unsupported products & return bundles
export const getBundles = (
  country = 'US',
  productcompletion = {},
  experimentation
) => {
  let bundles = handleExperimentation(experimentation);
  const returnBundles = Object.assign({}, bundles);
  const bundleOverride = _bundleOverrides[country];
  const countryLinks = _links[country] || {};

  // resolve links & images for each product
  Object.entries(products).forEach(([name, product]) => {
    // any product overrides
    if (productOverrides[country] && productOverrides[country][name]) {
      products[name] = Object.assign(
        products[name],
        productOverrides[country][name]
      );
    }

    // check if product is already active
    _setActivationStatus(product, productcompletion);

    product.link_url = _resolveLink(countryLinks, product.link);
    if (product.mobileApps) {
      product.androidLink_url = _resolveLink(countryLinks, product.androidLink);
      product.iosLink_url = _resolveLink(countryLinks, product.iosLink);
    }
    product.image =
      product.image && product.image !== '' ? product.image : 'logo-paypal';
  });

  for (const name in returnBundles) {
    let bundleObj = Object.assign({}, returnBundles[name]);

    // apply bundle overrides
    if (bundleOverride && bundleOverride[name]) {
      bundleObj = Object.assign(bundleObj, bundleOverride[name]);
    }

    if (bundleObj.disabled) {
      delete returnBundles[name];
    } else {
      // validate suggested products
      bundleObj.suggestedProducts = bundleObj.suggestedProducts || [];
      bundleObj.suggestedProducts = bundleObj.suggestedProducts.filter(
        product => {
          let productObj = products[product];
          return (
            productObj &&
            (!productObj.countries || productObj.countries.includes(country))
          );
        }
      );

      // validate hero product. if not valid / not available, get first product from suggested products array
      let heroProductObj = products[bundleObj.heroProduct];
      if (
        !heroProductObj ||
        (heroProductObj.countries &&
          !heroProductObj.countries.includes(country))
      ) {
        bundleObj.heroProduct = bundleObj.suggestedProducts.shift();
      }

      // if hero product itself not available, then don't display the bundle
      if (!bundleObj.heroProduct) {
        delete returnBundles[name];
      } else {
        returnBundles[name] = bundleObj;
      }
    }
  }
  return returnBundles;
};

export const getNonStickyHeaderStyles = sticky => {
  let res;
  if (!sticky) {
    res = {
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: '20px',
      paddingRight: '20px',
      maxWidth: '1170px',
      marginTop: '15px'
    };
  }
  return res;
};
